<template>
    <div class="m-rule-view">
        <h5 class="title"></h5>

        <div class="rule-text">
            <div v-for="(item,index) in rule_text" :key="index"><em class="tag" v-html="index+1"></em> <span v-html="item.text"></span></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.m-rule-view{

    @media screen and (min-width: 900px) {
        .title{
            width: 803px;
            height: 72px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/pc/title-4.png);
        }
        
        .rule-text{
            padding: 0 220px;
            font-size: 16px;
            color: #8d684b;
        }

        .rule-text>div{
            position: relative;
            margin-bottom: 25px;
            padding-left: 42px;
        }

        .rule-text b{
            color: #d45c3d;
        }   


        .tag{
            position: absolute;
            left: 0;
            top: 2px;
            display: inline-block;
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            background-color: #bc361b;
            border-radius: 5px;
            font-size: 14px;
            color: #f6efe4;
        }        

    }

    @media screen and (max-width: 899px) {
        .title{
            width: 695px;
            height: 72px;
            margin: 0 auto 25px;
            background-image: url(~@/assets/images/m/title-4.png);
        }
        
        .rule-text{
            padding: 0 10px;
            font-size: 24px;
            color: #8d684b;
        }

        .rule-text>div{
            position: relative;
            margin-bottom: 25px;
            padding-left: 42px;
        }

        .rule-text b{
            color: #d45c3d;
        }   


        .tag{
            position: absolute;
            left: 0;
            top: 2px;
            display: inline-block;
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            background-color: #bc361b;
            border-radius: 5px;
            font-size: 14px;
            color: #f6efe4;
        }          
    }
}
</style>

<script>
export default {
    data (){
        return {
            rule_text : [
                    {
                        tag : '',
                        text : '活动时间：9月7日10:00-9月28日23:59。',
                    },
                    {
                        tag : '',
                        text : '玩家在游戏内组建小队后，可通过分享页面来邀请好友入队。',
                    },
                    {
                        tag : '',
                        text : '点击其他玩家分享出来的页面邀请链接，同意入队后，将发送申请给队长，队长于游戏内同意后，则玩家入队成功。',
                    },
                    {
                        tag : '',
                        text : '如果一个玩家同时向多个队长提出入队申请，以先同意的为准。',
                    },
                    {
                        tag : '',
                        text : '当小队成功拥有5人后，该队的所有人都可以在活动页面上领取【梦之队集结大礼包】（仅可领取1次）与【小队福利包】（每周1次，最多可领3次），必须在满5人的组队情况下才可领取。',
                    },
                    {
                        tag : '',
                        text : '加入队伍后，每个人都将获得1份锦鲤抽奖码，中奖码将于9月28日晚虎牙直播间（537010）、抖音直播间（ID：梦三国）现场揭晓。',
                    }, 
                    {
                        tag : '',
                        text : '活动期间内，通过组队成功、每日签到、分享页面、购买特惠包等方式，可获得【燃梦火炬】，集齐指定数量后，可于游戏内兑换【共襄盛举大礼包】。',
                    }, 
                    {
                        tag : '',
                        text : '每日签到可获得签到礼1份，分享页面可获得分享礼1份，如有玩家通过你分享的页面进入，则双方同时获得互助礼1份。',
                    }, 
                    {
                        tag : '',
                        text : '当你所处小队满5人后，同时你所属的军团累计加入梦之队的总人数超过20人，可领取一份军团齐心礼同时解锁内购礼购买资格。',
                    },
                    {
                        tag : '',
                        text : '礼包将于3个工作日内发放至军师邮件，请注意查收。',
                    },
                    {
                        tag : '',
                        text : '活动过程中，如果遇到任何问题，请及时联系我们的客服小姐姐（电话热线：0571-56697640）。',
                    },                                                            
            ],
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/views/evtrule.vue